<template>
  <div>
    <div class="main-login"  v-if="!usuarioLogado">
      <div class="wrapper">
          <figure class="logo">
              <img src="./assets/logo.png">
              <figcaption>
                  <h1>RAT online v1.1</h1>               
              </figcaption>
          </figure>  
          <div class="form-bootstrap">
             <div class="card">
                <div class="input-group">
                    <label>Login</label>  
                    <input type="text" v-model="usuario.login">   
                </div>     
                <div class="input-group">
                    <label>Sehna</label>  
                    <div class="senha-wrapper">
                      <input :type="mostrarSenha ? 'text' : 'password'" v-model="usuario.senha">
                      <button
                        type="button"
                        class="toggle-senha"
                        @click="mostrarSenha = !mostrarSenha"
                        :title="mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'"
                      >
                        <img src="./assets/eye.png" v-if="mostrarSenha">
                        <img src="./assets/eye-crossed.png" v-else>
                      </button>
                    </div>
                </div>       
                <div class="form-actions">
                    <button class="btn btn-primary" @click="efetuarLogin">Acessar</button>
                </div>      
              </div>                                               
          </div>
        <div class="main-dk">
          <span>Sistema desenvolvido por</span>
          <a href="https://www.dksoftwares.com.br/" target="_blank"><img src="./assets/dk-logo.png"/></a>
        </div>
      </div>
    </div>

    <div v-if="usuarioLogado"> 
      <router-view/>
    </div>
  </div>
</template>

<script>
import api from './services/api.js';
export default {
  data: () => ({

      usuario: {
          login:'',
          senha:''
      },
      usuarioLogado: false,
      mostrarSenha: false
  }),
  methods: {
        efetuarLogin () {
            console.log('login');  
            console.log(this.usuario);  

            api.post('/tecnico/acesso',this.usuario)        
            .then(response => {  
                console.log('login '+response.data.retorno);
                console.log(response);

                if (response.status==200){
                    this.usuarioLogado = true;
                    localStorage.setItem('usuarioLogado', 'true'); 
                    localStorage.setItem('codUsuarioLogado', response.data); 
                    this.$router.push('/');  
                }
                else    
                    alert(decodeURIComponent(response.data).replaceAll('+',' '));                        


            }).catch( error => {
                console.log(error);  
                alert('Error - Login \n'+'-'+error.response.data);
            });              

        }
  }
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600&family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');
  @import './css/reset.css';
  @import './css/index.css';
  @import './css/components/main-login.css';
  @import './css/components/form-bootstrap.css';
</style>
